import React, { MouseEvent, PropsWithChildren } from 'react'

import { useHistory } from 'react-router-dom'

import { AddToCart, LinkNavigation } from './ListCard'

type List =
  | { navType: AddToCart; onPress: () => void }
  | { navType: LinkNavigation; link?: string }

const buttonReset = {
  appearance: 'none' as const,
  background: 'transparent',
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  font: 'inherit',
  textDecoration: 'none',
  display: 'block',
  width: '100%',
  textAlign: 'left' as const,
  color: 'inherit',
}

/**
 * Wraps a clickable card. For `navType === 'activity'` renders a <button>
 * (add-to-cart, no URL). For `navType === 'menu' | 'workshop'` renders a
 * real <a href> so the browser handles copy-link, open-in-new-tab and
 * middle-click natively. Plain left-click is intercepted and routed
 * through react-router via history.push.
 *
 * Renamed from ToucheWrapper in OB-506. Was originally named when it
 * wrapped TouchableOpacity (pre-OB-499).
 */
export const CardNavWrapper = (props: PropsWithChildren<List>) => {
  const history = useHistory()

  if (props.navType === 'activity') {
    return (
      <button type="button" style={buttonReset} onClick={() => props.onPress()}>
        {props.children}
      </button>
    )
  }

  const target = props.link
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (
      !target ||
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.altKey ||
      e.ctrlKey ||
      e.shiftKey
    ) {
      return
    }
    e.preventDefault()
    history.push(target)
  }

  return (
    <a href={target} onClick={handleClick} style={buttonReset}>
      {props.children}
    </a>
  )
}
